import FilterListIcon from '@mui/icons-material/FilterList'
import Avatar from '@mui/material/Avatar'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import {lightBlue} from '@mui/material/colors'
import {alpha} from '@mui/material/styles'
import {IUserFE} from 'interfaces/IUserFE'
import React from 'react'
import {useToolbarContext} from '../toolbar/ToolbarProvider'
import {IFilterControlOptions} from './CFilters'
import FilterPanel from './FilterPanel'

type Anchor = 'top' | 'left' | 'bottom' | 'right'

interface Props {
  parentSaveFilters: (filters: IFilterControlOptions[], filterType: string) => void
  parentResetFilters: (filters: IFilterControlOptions[], entity_type: string) => void
  currUser?: IUserFE
  setStateFilters?: React.Dispatch<
    React.SetStateAction<{type: string; filters: Record<string, any>}[]>
  >
  filterControlOptions?: IFilterControlOptions[] | undefined
  entity: string
  subEntity?: string
  title: string
  anchor?: 'left' | 'top' | 'right' | 'bottom'
  position?: string
  float?: string
  top?: string
  additional_data?: any
}

//entity is used to call and to store in profile, if it contains
export default function UniversalFilter(props: Props) {
  const {expanded, children} = useToolbarContext()
  const profileEntityType = props.entity + `${props.subEntity ? '|' + props.subEntity : ''}`
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent | any) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return
      }

      setState({...state, [anchor]: open})
    }
  return (
    <Box>
      <Box
        sx={{
          position: props.position ? props.position : 'fixed',
          top: props.top ? props.top : children ? '145px' : '70px',
          right: 5,
          fontSize: '10px',
          float: props.float ? props.float : '',
        }}
      >
        <IconButton color={'primary'} onClick={toggleDrawer(props.anchor ?? 'right', true)}>
          <Badge
            id={'hello-badge'}
            badgeContent={
              props.currUser?.profile?.filters
                ?.find((f) => f.type === profileEntityType)
                ?.filters?.filter((f) => f.fieldValue)?.length ?? 0
            }
            showZero={true}
            color={
              props.currUser?.profile?.filters
                ?.find((f: any) => f.type === profileEntityType)
                ?.filters?.filter((f: any) => f.fieldValue)?.length
                ? 'secondary'
                : 'info'
            }
            variant={'standard'}
            sx={{'& span': {transform: 'translate(0%, -0%)', zIndex: 0}}}
          >
            <Avatar
              sx={{
                backgroundColor: alpha(lightBlue[700], 0.7),
                color: 'white',
                fontSize: '10px',
                width: '48px',
                height: '48px',
              }}
            >
              <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <FilterListIcon />
                <span style={{color: 'white', letterSpacing: '.1rem'}}>Filters</span>
              </Box>
            </Avatar>
          </Badge>
        </IconButton>
      </Box>
      <React.Fragment key={props.anchor ?? 'right'}>
        <Drawer
          anchor={props.anchor ?? 'right'}
          open={state[props.anchor ?? 'right']}
          onClose={toggleDrawer(props.anchor ?? 'right', false)}
          PaperProps={{
            sx: {
              width: '60em',
            },
          }}
        >
          <FilterPanel
            parentSaveFilters={props.parentSaveFilters}
            parentResetFilters={props.parentResetFilters}
            entity={props.entity}
            subEntity={props.subEntity}
            title={props.title}
            filterControlOptions={props.filterControlOptions}
            toggleDrawerShut={toggleDrawer(props.anchor ?? 'right', false)}
            additional_data={props.additional_data}
          />
        </Drawer>
      </React.Fragment>
    </Box>
  )
}
